export const initialPage = 0;
export const pageSize = 100;
